import { flatten } from 'lodash'
import { IPriceConfiguration } from '../../models/Price'
import { IGridPrice } from '../../models/Price/mappers/mapResponseToPriceGrid'
import { IRoom } from '../../models/Room'
import { priceIsOk } from './index'

const extractPrice = (
  key: string,
  price: IGridPrice,
  room: IRoom,
  isPricePerPerson: boolean,
  isKidsPrice: boolean,
  kidIds: number[],
): number[] => {
  const { roomSize } = room
  const nRoomSize = +roomSize
  const prices = []
  if (isPricePerPerson) {
    for (let i = 1; i <= +nRoomSize; i++) {
      prices.push(price[key][i])
    }
  } else {
    prices.push(price[key][roomSize])
  }

  if (+room.additionalBeds) {
    prices.push(price.extrabed[key])
  }

  if (isKidsPrice) {
    kidIds.forEach(kidId => {
      const kidPrice = price.kids.find(k => k.kidId === kidId)
      prices.push(kidPrice ? kidPrice[key] : null)
    })
  }

  return prices
}

export const hasEmptyPricesInCategory = (
  price: IGridPrice,
  room: IRoom,
  config: IPriceConfiguration,
): boolean => {
  const kidIds = config.kids.map(k => +k.id)
  const keys = ['standard']
  if (config.weekendPrice) {
    keys.push('weekend')
  }
  if (config.stay) {
    if (config.stayShortTo) {
      keys.push('short')
    }
    if (config.stayLongFrom) {
      keys.push('long')
    }
  }
  const prices = flatten(
    keys.map(key =>
      extractPrice(
        key,
        price,
        room,
        config.pricePerPerson,
        config.kidsPrice,
        kidIds,
      ),
    ),
  )

  return (
    prices.some(p => priceIsOk(p)) &&
    prices.some(p => p === undefined || p === null)
  )
}
